import { navigate } from 'gatsby';
import React from 'react';

import { currentUserStore } from '../commons/user';
import { scrollToHash, scrollToHeroEnd } from "./scrolling";

const doBuildMessages = (htmlMessages: Array<string>) => {
  return (
    <div className="container-content layout-container bg-blue-100">
      <div className="status-messages-inner layout-content">
        {htmlMessages.map((htmlMessage, index) => (
          <div
            className="prose md:prose-xl"
            key={index}
            dangerouslySetInnerHTML={{ __html: htmlMessage }}
          />
        ))}
      </div>
    </div>
  )
}

const doRedirect = async (url: string, htmlMessages?: Array<string>, historyState?: Object) => {
  if (typeof window !== 'undefined' && window.location.href === `${window.location.origin}${url}`) {
    window.location.reload();
    throw new Error('Stop script execution to reload the current page.');
  } else {
    // In case the url to redirect to has the same domain as the current window
    // location, we strip that, otherwise the navigate performs incorrect (for
    // some reason it removes the search parameters).
    const navigateURL = (typeof window !== 'undefined' && url.startsWith(window.location.origin)) ? url.slice(window.location.origin.length) : url;
    await navigate(navigateURL, {
      state: {
        messages: htmlMessages,
        ...(typeof historyState !== 'undefined' ? historyState : {})
      },
    });
    // In case the new page has a hash, we want to scroll to it.
    scrollToHash();
  }
}

/**
 * Function to be used for the buildMessage parameter of the embedded iframes.
 */
export const buildMessages = (scrollToHero: boolean = true, historyState?: Object) =>
  function(htmlMessages: Array<string>) {
    if (scrollToHero) {
      scrollToHeroEnd();
    }
    if (typeof historyState !== 'undefined') {
      history.pushState(historyState, '');
    }
    return doBuildMessages(htmlMessages);
  }

/**
 * Function to be used for the redirect parameter of the embedded iframes.
 */
export const redirect = async (url: string, htmlMessages?: Array<string>) => {
  doRedirect(url, htmlMessages);
}

/**
 * Function to be used for the redirect parameter of the embedded forms, which
 * merges additional state into the history. The historyState needs to be an
 * object.
 */
export const redirectWithAdditionalState = (historyState?: Object) =>
  async function (url: string, htmlMessages?: Array<string>) {
    doRedirect(url, htmlMessages, historyState);
  }

/**
 * Function to be used for the redirect parametrs of the embedded iframes which
 * also updates the state of the user.
 *
 * This basically just updates the user status and then calls the redirect()
 * function. In case we need more cases like this one, we should come up with a
 * more clever composable implementation here.
 */
export const redirectWithUserUpdate = async (url: string, htmlMessages?: Array<string>) => {
  currentUserStore.getState().update();
  redirect(url, htmlMessages);
}
